<section id="cat-section-1">
  <div id="cat-div-1"
    *ngIf="!isSizeMobile"
    class="d-flex flex-column justify-content-start border-bottom"
  >
    <span id="cat-span-1" class="copec-bold-20">Todos los beneficios</span>
    <span id="cat-span-2" class="copec-lg-14">{{this.countBenefit}} resultados</span>
  </div>
  <div id="cat-div-2"
    *ngIf="isSizeMobile"
    class="d-flex justify-content-between align-items-center border-bottom"
  >
    <span id="cat-span-3" class="copec-bold-20">Filtrar</span>
    <div id="cat-div-3" class="copec-rg-16 color-second-dark-blue">
      <span id="cat-span-4">Quitar todos</span>
      <span id="cat-span-5" class="ms-4" (click)="closeFilter()">x</span>
    </div>
  </div>
  <mat-accordion id="cat-mat-1">
    <mat-expansion-panel id="cat-mat-2" [expanded]="isExpanded">
      <mat-expansion-panel-header id="cat-mat-3">
        <mat-panel-title id="cat-mat-4" class="copec-bold-16">Categorías</mat-panel-title>
      </mat-expansion-panel-header>
      <div id="cat-cat-div-{{ category.idcategory }}"
        class="tab d-flex align-items-center"
        [class.active]="selectedCategory === category.idcategory"
        *ngFor="let category of categories"
        (click)="filterBenefitsByCategory(category)"
      >
        <img  id="cat-cat-img-1-{{ category.idcategory }}"  class="fa-regular" src="{{ category.icon }}" alt=""/>
        <span id="cat-cat-span-{{ category.idcategory }}" class="copec-lg-16 color-black ms-2">{{ category.description }}</span>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion id="cat-mat-5">
    <mat-expansion-panel id="cat-mat-6" [expanded]="expandPlan">
      <mat-expansion-panel-header id="cat-mat-7">
        <mat-panel-title id="cat-mat-8" class="copec-bold-16">Planes</mat-panel-title>
      </mat-expansion-panel-header>
      <div id="cat-plan-div-{{plan.id}}" class="d-flex align-items-center pb-3" *ngFor="let plan of plans">
        <input
          type="checkbox"
          id="{{plan.id}}"
          name="{{plan.titleplan}}"
          value="{{plan.id}}"
          (change)="filterBenefitsByPlan($event)"
          [checked]="checkSelectedfromBeforePlan.includes(plan.id)"
        />
        <label id="cat-plan-label-{{plan.id}}" for="plan.name" class="ms-2">{{ plan.titleplan }}</label>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion id="cat-mat-9">
    <mat-expansion-panel id="cat-mat-10" [expanded]="expandAntiques">
      <mat-expansion-panel-header id="cat-mat-11">
        <mat-panel-title class="copec-bold-16" id="cat-mat-12"
          >Antigüedad requerida</mat-panel-title
        >
      </mat-expansion-panel-header>
      <div id="cat-antiquity-div-{{antiquity}}"  class="d-flex align-items-center pb-3" *ngFor="let antiquity of antiques">
        <input
          type="checkbox"
          id="{{antiquity}}"
          name="{{antiquity}}"
          value="{{antiquity}}"
          (change)="filterBenefitsByAntiquity($event)"
          [checked]="checkSelectedfromBeforeAntiques.includes(antiquity)"
        />
        <label id="cat-antiquity-label-{{antiquity}}" for="antiquity.description" class="ms-2">{{antiguedad(antiquity) }}</label>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion id="cat-mat-13">
    <mat-expansion-panel id="cat-mat-14" [expanded]="expandTypes">
      <mat-expansion-panel-header id="cat-mat-15">
        <mat-panel-title id="cat-mat-16" class="copec-bold-16">Beneficiarios</mat-panel-title>
      </mat-expansion-panel-header>
      <div id="cat-beneficiaryType-div-{{beneficiaryType.id}}"
        class="d-flex align-items-center pb-3"
        *ngFor="let beneficiaryType of beneficiaryTypes"
      >
        <input
          type="checkbox"
          id="{{beneficiaryType.id}}"
          name="{{beneficiaryType.description}}"
          value="{{beneficiaryType.id}}"
          (change)="filterBenefitsByBeneficiaryTypes($event)"
          [checked]="checkSelectedfromBeforeTypes.includes(beneficiaryType.id)"
        />
        <label id="cat-antiquity-label-{{beneficiaryType.id}}" for="beneficiaryType.description" class="ms-2">{{ beneficiaryType.description }}</label>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div id="cat-div-8" *ngIf="isSizeMobile" class="container-apply-button">
    <button id="cat-but-apply" class="apply-button copec-rg-16">Aplicar</button>
  </div>
</section>
